<template>
  <v-list-tile draggable
    :class="['file', 'it-hv', { 'blue': isSelecting, 'lighten-4': isSelecting }, printExt]"
    @dragstart="dragstart"
    @dragend="dragend"
    :disabled="!isActive || isLoading">
    <v-list-tile-avatar :class="printColor"><font-awesome-icon :icon="printIcon" /></v-list-tile-avatar>
    <v-list-tile-content v-if="$vuetify.breakpoint.smAndUp">
      <v-container grid-list-md class="px-0">
        <v-layout wrap class="transparent">
          <v-flex xs8 class="pa-0 text-truncate">
            <button type="button" class="flex name-link text-truncate" @click.stop="open">{{ printName }}</button>
            <div class="px-1 caption">
              <span v-if="isLocked" class="mr-2"><font-awesome-icon :icon="['fas', 'lock']" size="xs" />&nbsp;{{ printAuthor }}</span>
              <span v-if="isSharedDirectory || isShared" class="mr-2"><font-awesome-icon :icon="['fas', 'link']" size="xs" />&nbsp;共有中</span>
            </div>
          </v-flex>
          <v-flex xs2 align-self-center class="caption grey--text text--darken-2 pa-0 text-truncate">{{ printModifiedAt }}</v-flex>
          <v-flex xs2 align-self-center class="caption grey--text text--darken-2 pa-0 text-truncate">{{ printSize }}</v-flex>
        </v-layout>
      </v-container>
    </v-list-tile-content>
    <v-list-tile-content v-else>
      <v-list-tile-title>
        <button type="button" class="flex name-link text-truncate" @click.stop="open">{{ printName }}</button>
      </v-list-tile-title>
      <v-list-tile-sub-title class="caption">{{ printModifiedAt }} {{ printSize }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-menu bottom left offset-y :close-on-click="true">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="blue--text text--darken-2" :loading="isLoading"><v-icon>more_vert</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-tile @click="download">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'download']"></font-awesome-icon></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>ダウンロード</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
const DEFAULT = {
  STATUS: {
    LOADING: false,
    SELECTING: false,
    DRAGGING: false
  }
}
const FILES = {
  FILE: {
    icon: 'file',
    color: 'gray--text text--darken-2'
  },
  DOC: {
    icon: 'file-word',
    color: 'blue--text text--darken-3'
  },
  DOCX: {
    icon: 'file-word',
    color: 'blue--text text--darken-3'
  },
  XLS: {
    icon: 'file-excel',
    color: 'green--text text--darken-3'
  },
  XLSX: {
    icon: 'file-excel',
    color: 'green--text text--darken-3'
  },
  PPT: {
    icon: 'file-powerpoint',
    color: 'orange--text text--darken-3'
  },
  PPTX: {
    icon: 'file-powerpoint',
    color: 'orange--text text--darken-3'
  },
  PDF: {
    icon: 'file-pdf',
    color: 'red--text text--darken-3'
  },
  PNG: {
    icon: 'file-image',
    color: 'grey--text text--darken-4'
  },
  JPG: {
    icon: 'file-image',
    color: 'grey--text text--darken-4'
  },
  JPEG: {
    icon: 'file-image',
    color: 'grey--text text--darken-4'
  },
  BMP: {
    icon: 'file-image',
    color: 'grey--text text--darken-4'
  },
  GIF: {
    icon: 'file-image',
    color: 'grey--text text--darken-4'
  },
  TXT: {
    icon: 'file-alt',
    color: 'blue-grey--text text--darken-1'
  },
  MD: {
    icon: 'file-invoice',
    color: 'blue-grey--text text--darken-1'
  },
  ZIP: {
    icon: 'file-archive',
    color: 'brown--text'
  },
  EML: {
    icon: 'envelope',
    color: 'blue--text text--darken-1'
  }
}
export default {
  name: 'filer-file',
  props: [
    'cid',
    'authed',
    'shared',
    'trashed',
    'status',
    'item',
    'selectable'
  ],
  components: {
  },
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.STATUS.LOADING,
          selecting: DEFAULT.STATUS.SELECTING,
          dragging: DEFAULT.STATUS.DRAGGING
        }
      },
      meta: {
        icons: {
          valid: Object.keys(FILES)
        },
        size: {
          unit: ['B', 'B', 'B', 'KB', 'KB', 'KB', 'MB', 'MB', 'MB', 'GB', 'GB', 'GB'],
          offset: [1, 2, 3, 1, 2, 3, 1, 2, 3, 1, 2, 3]
        }
      }
    }
  },
  methods: {
    state: function (req) {
      if (
        req &&
        req.type &&
        req.status != null
      ) {
        this.$set(this.config.status, req.type, req.status)
      }
    },
    open: function () {
      if (this.$props.item) {
        this.$emit('emit', {
          action: 'open',
          data: this.$props.item
        })
      }
    },
    rename: function () {
      if (this.$props.item) {
        this.$emit('emit', {
          action: 'rename',
          data: this.$props.item
        })
      }
    },
    trash: function () {
      if (this.$props.item && this.$props.status) {
        this.$set(this.config.status, 'loading', true)
        this.$emit('emit', {
          action: this.$props.status.permits.trash ? 'trash' : 'restore',
          data: this.$props.item
        })
      }
    },
    replace: function (files) {
      if (this.$props.item && files && files.length) {
        this.$emit('emit', {
          action: 'replace',
          data: {
            dest: this.$props.item,
            file: files[0]
          }
        })
      }
    },
    share: function () {
      if (this.$props.item && this.$props.status) {
        this.$emit('emit', {
          action: 'share',
          data: this.$props.item
        })
      }
    },
    unshare: function () {
      if (this.$props.item && this.$props.status) {
        this.$emit('emit', {
          action: 'unshare',
          data: this.$props.item
        })
      }
    },
    select: function (e) {
      if (
        this.$props.item &&
        e &&
        e.type &&
        this.$props.selectable
      ) {
        if (e.type === 'mousedown') {
          if (e.metaKey) {
            this.state({
              type: 'selecting',
              status: !this.config.status.selecting
            })
            this.$emit('emit', {
              action: 'select',
              data: {
                item: this.$props.item,
                event: e
              }
            })
          } else if (!this.config.status.selecting) {
            this.state({
              type: 'selecting',
              status: true
            })
            this.$emit('emit', {
              action: 'select',
              data: {
                item: this.$props.item,
                event: e
              }
            })
          }
        } else if (e.type === 'click') {
          if (!this.config.status.dragging) {
            this.state({
              type: 'selecting',
              status: true
            })
            this.$emit('emit', {
              action: 'select',
              data: {
                item: this.$props.item,
                event: e
              }
            })
          }
        }
      }
    },
    dragstart: function (e) {
      this.$set(this.config.status, 'dragging', true)
      this.$emit('emit', {
        action: 'dragstart',
        data: e
      })
    },
    dragend: function () {
      this.$set(this.config.status, 'dragging', false)
    },
    download: function () {
      if (this.$props.item && this.$props.item.id) {
        this.$set(this.config.status, 'loading', true)
        let uid = this.$store.getters['author/get']('tokens').box
        let url = this.$url.api + 'box/download/' + this.$props.item.id
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, {
            uid: uid
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              window.location.href = res.data.data
            } else if (
              res.data &&
              res.data.data &&
              res.data.data.response &&
              res.data.data.response.body &&
              res.data.data.response.body.code
            ) {
              let code = res.data.data.response.body.code
              let err = this.$error.box.file.open[code] ? this.$error.box.file.open[code] : ''
              if (err) {
                this.$store.dispatch('notifier/addAlert', {
                  title: 'ファイルのダウンロード',
                  message: err
                })
              }
            }
          })
        })
      }
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isActive () {
      return !!(
        this.$props.item &&
        this.$props.item.active
      )
    },
    isLocked () {
      return !!(
        this.$props.item &&
        this.$props.tags &&
        this.$props.tags.authed
      )
    },
    isSetClientId () {
      return !!this.$props.cid
    },
    isAuthed () {
      return this.$props.authed && !(
        this.$props.item.tags &&
        this.$props.item.tags.authed &&
        this.$props.item.tags.authed !== this.$store.getters['author/get']('userid')
      )
    },
    isShared () {
      return !!(
        this.$props.item &&
        this.$props.item.tags &&
        this.$props.item.tags.shared
      )
    },
    isSharedDirectory () {
      return this.$props.shared
    },
    isTrashed () {
      return this.$props.trashed
    },
    isItemLoading () {
      return (
        this.$props.item &&
        this.$props.item.status &&
        this.$props.item.status.loading
      )
    },
    isCoreLoading () {
      return this.$props.status && this.$props.status.loading
    },
    isSelecting () {
      return this.config.status.selecting
    },
    isInserted () {
      return (
        this.$props.item &&
        this.$props.item.status &&
        this.$props.item.status.inserting
      )
    },
    printIcon () {
      if (this.$props.item && this.$props.item.name) {
        let ext = this.$props.item.name.split('.').pop()
        return (ext !== this.$props.item.name && this.meta.icons.valid.includes(ext.toUpperCase())) ? ['fas', FILES[ext.toUpperCase()].icon] : ['fas', FILES.FILE.icon]
      } else {
        return ['fas', FILES.FILE.icon]
      }
    },
    printColor () {
      if (this.$props.item && this.$props.item.name) {
        let ext = this.$props.item.name.split('.').pop()
        return (ext !== this.$props.item.name && this.meta.icons.valid.includes(ext.toUpperCase())) ? FILES[ext.toUpperCase()].color : FILES.FILE.color
      } else {
        return FILES.FILE.color
      }
    },
    printExt () {
      if (this.$props.item && this.$props.item.name) {
        let ext = this.$props.item.name.split('.').pop()
        return (ext !== this.$props.item.name) ? ext.toLowerCase() : ''
      } else {
        return ''
      }
    },
    printAuthor () {
      return (
        this.$props.item &&
        this.$props.item.tags &&
        this.$props.item.tags.authed
      ) ? this.$props.item.tags.authed : ''
    },
    printName () {
      if (this.$props.item && this.$props.item.name) {
        if (this.$props.trashed) {
          let nameInfo = this.$props.item.name.split('_')
          let date = nameInfo.shift()
          return '（' + this.$moment(date).format('YYYY年MM月DD日') + ' 削除）' + nameInfo.join('_')
        } else {
          return this.$props.item.name
        }
      } else {
        return ''
      }
    },
    printModifiedAt () {
      return (
        this.$props.item &&
        this.$props.item.modified_at
      ) ? this.$moment(this.$props.item.modified_at).format('YYYY年MM月DD日') : ''
    },
    printSize () {
      if (
        this.$props.item &&
        this.$props.item.size
      ) {
        let size = '' + this.$props.item.size
        let unit = this.meta.size.unit[size.length - 1] ? this.meta.size.unit[size.length - 1] : 'B'
        let rounded = this.meta.size.offset[size.length - 1] ? size.substr(0, this.meta.size.offset[size.length - 1]) : size
        return rounded + ' ' + unit
      } else {
        return ''
      }
    },
    getItem () {
      return this.$props.item
    }
  }
}
</script>

<style lang="scss">
.filer {
  .file {
    .name-link {
      &:hover {
        text-decoration: underline !important;
      }
    }
  }
}
</style>
